import { Component } from 'react';
import cx from 'classnames';
import styles from '../../styles/homePage/question.scss';
import ReactMarkdown from 'react-markdown';
import { handleTrack } from '../../utils/trackActions';

interface State {
  open: boolean;
}

interface Props {
  linkObj: any;
  index?: number;
  last?: boolean;
  singular?: boolean;
  collapsed?: boolean;
}

class Question extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      open: props.collapsed ? false : true,
    };
    this.toggleFaq = this.toggleFaq.bind(this);
  }
  public toggleFaq() {
    this.setState({
      open: !this.state.open,
    });
    handleTrack({ label: `faq_toggleButton_${this.props.linkObj.question}` });
  }
  public getAnswer(answer: any) {
    return (
      <pre className={styles.answer}>
        {answer.preText ? answer.preText : answer}
        {answer.points ? (
          <ul>
            {answer.points.map((point, i) => {
              return (
                <li className="mb10" key={i}>
                  <ReactMarkdown source={point} />
                </li>
              );
            })}
          </ul>
        ) : null}
      </pre>
    );
  }
  public render() {
    const { linkObj, index, last, singular } = this.props;
    return (
      <li
        className={cx(
          styles.link,
          'columns',
          { 'large-6': !singular },
          { 'medium-6': !singular },
          { [`${styles.open}`]: this.state.open, [`${styles.left}`]: last },
          `${
            index && index % 2 === 0
              ? [`${styles['clear-left']}`]
              : [`${styles['clear-right']}`]
          }`
        )}
      >
        <a className={styles.question} onClick={this.toggleFaq}>
          {linkObj.question}
        </a>
        {this.state.open ? this.getAnswer(linkObj.answer) : null}
      </li>
    );
  }
}

export default Question;



// WEBPACK FOOTER //
// ./components/homePage/question.tsx